<div class="media-access-denied">
  <fa-duotone-icon [icon]="icon()"></fa-duotone-icon>
  <p>{{ text() }}</p>
  <button class="media-access-denied__tutorial-btn" (click)="onShowTutorial.emit()">
    {{ 'How to fix this' | translate }}
  </button>
</div>
